import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';
import { Lingua } from '../_model/lingua.model';
import { TipoDocumento } from '../_model/tipo-documento.model';
import { TipoCliente } from '../_model/tipo-cliente.model';
import { modaleAvviso } from '../modali/modale-avviso/modale-avviso.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Prodotto } from '../_model/prodotto.model';
import { ProductGroup } from '../_model/product-group.model';
import { ParametroProdotto } from '../_model/parametro-prodotto.model';
import { QuoteDetail, QuoteRequest, RecoverQuote, ValidazioneContattiRequest } from '../_model/quote.model';
import { Cliente } from '../_model/cliente.model';
@Injectable({ providedIn: 'root' })
export class ApiService {
	constructor(
		private http: HttpClient,
		private modalService: NgbModal,
	) {}

	//dominio
	isAppAlive() {
		return this.http.post(environment.apiUrl + 'common/alive', {}).pipe(
			map((res: any) => {
				modaleAvviso(this.modalService, 'Alive', res.result);
			}),
		);
	}

	elencoLingue() {
		return this.http.post(environment.apiUrl + 'common/languages', {}).pipe(map((res: any) => res.result as Lingua[]));
	}

	elencoTipiDocumenti() {
		return this.http.post(environment.apiUrl + 'common/document-type', {}).pipe(map((res: any) => res.result as TipoDocumento[]));
	}

	//TODO: collegare
	elencoTipiClienti() {
		return this.http.post(environment.apiUrl + 'common/customer-type', {}).pipe(map((res: any) => res.result as TipoCliente[]));
	}

	//product
	elencoProdotti(body?: { parameterOptionIds: number[] }, tenantId?: number, idProductGroup?: number) {
		const b: any = body ? { ...body } : {};
		if (tenantId) b['tenantId'] = tenantId;
		if (idProductGroup) b['idProductGroup'] = idProductGroup;
		return this.http.post(environment.apiUrl + 'product/enabledProducts', b).pipe(map((res: any) => res.result as Prodotto[]));
	}

	elencoProdottiPerTenant(tenantId: number, language = 'it', idProductGroup?: number) {
		const body: any = { tenantId, language, parameterOptionIds: [] };
		if (idProductGroup) body['idProductGroup'] = idProductGroup;
		return this.http
			.post(environment.apiUrl + 'product/enabledProducts', body)
			.pipe(map((res: any) => res.result as Prodotto[]));
	}

	elencoGruppiProdotti(tenantId?: number, language = 'it') {
		const body: any = { language };
		if (tenantId) body['tenantId'] = tenantId;
		return this.http
			.post(environment.apiUrl + 'product/productGroups', body)
			.pipe(map((res: any) => res.result as ProductGroup[]));
	}

	elencoParametriProdotti() {
		return this.http.post(environment.apiUrl + 'product/enabledParameters', {}).pipe(map((res: any) => res.result as ParametroProdotto[]));
	}

	insertQuote(body: QuoteRequest) {
		return this.http.post(environment.apiUrl + 'quote/insertQuote', body).pipe(map((res: any) => res.result));
	}

	validaContatti(body: ValidazioneContattiRequest) {
		return this.http.post(environment.apiUrl + 'quote/validateContacts', body).pipe(map((res: any) => res.result));
	}

	elencoProdottiAggiuntivi(tenantId?: number, idProductGroup?: number) {
		return this.http
			.post(environment.apiUrl + 'product/additionalProducts', { tenantId: tenantId || null, idProductGroup: idProductGroup || null })
			.pipe(map((res: any) => res.result as Prodotto[]));
	}

	insertCustomer(body: Cliente) {
		return this.http.post(environment.apiUrl + 'quote/insertCustomer', body).pipe(map((res: any) => res.result as Cliente[]));
	}

	getMunicipalitiesByProvince(provinceAbbreviation: string) {
		return this.http.post(environment.apiUrl + 'quote/getMunicipalitiesByProvince', { provinceAbbreviation, language: 'it' }).pipe(map((res: any) => res.result as any[]));
	}

	getPostalCodesByIstatCode(istatCode: string) {
		return this.http.post(environment.apiUrl + 'quote/getPostalCodesByIstatCode', { istatCode, language: 'it' }).pipe(map((res: any) => res.result as any[]));
	}

	getAllCountries() {
		return this.http.post(environment.apiUrl + 'quote/getAllCountries', { id: null, language: 'it' }).pipe(map((res: any) => res.result as { iso_code_2: string; description: string }[]));
	}

	searchCountriesByDescription(description: string) {
		return this.http
			.post(environment.apiUrl + 'quote/searchCountriesByDescription', { description, language: 'it' })
			.pipe(map((res: any) => res.result as { iso_code_2: string; description: string }[]));
	}

	eliminaDocAssicurato(body: { documentId: number; customerId: number }) {
		return this.http.post(environment.apiUrl + 'quote/deleteCustomerDocument', body);
	}

	addDetailToQuote(body: QuoteDetail) {
		return this.http.post(environment.apiUrl + 'quote/addDetailToQuote', body).pipe(map((res: any) => res.result));
	}

	dettaglioCarrello(body: QuoteDetail) {
		return this.http.post(environment.apiUrl + 'quote/quoteDisplay', body).pipe(map((res: any) => res.result));
	}

	avviaPagamento(body: { quoteId: number; customerId: number }) {
		return this.http
			.post(environment.apiUrl + 'payment/request-purchase', body)
			.pipe(map((res: any) => res.result as { parametriPagamento: any[]; urlPagamento: string }));
	}

	getDatiFromCF(body: { codiceFiscale: string }) {
		return this.http.post(environment.apiUrl + 'quote/getAgeFromCodiceFiscale', body).pipe(map((res: any) => res.result));
	}

	recoverQuote(body: { token: string }) {
		return this.http.post(environment.apiUrl + 'quote/recoverQuote', body).pipe(map((res: any) => res.result as RecoverQuote));
	}

	cambiaConsensi(body: { token: string; acceptedMarketing: boolean; acceptedPrivacy: boolean }) {
		return this.http.post(environment.apiUrl + 'quote/changeConsentQuote', body).pipe(map((res: any) => res));
	}

	unsubscribePromemoria(body: { token: string }) {
		return this.http.post(environment.apiUrl + 'quote/unsubscribe', body).pipe(map((res: any) => res));
	}

	getDocumentiObbligatori(body: { id: number }) {
		return this.http.post(environment.apiUrl + 'product/documentsRequired', body).pipe(map((res: any) => res.result));
	}

	getPolicyDocuments(body: { tenantId?: number; productId: number; language?: string }) {
		return this.http.post(environment.apiUrl + 'product/policyDocuments', body).pipe(map((res: any) => res.result as string[]));
	}

	downloadPolicyDocument(body: { tenantId?: number; productId: number; docName: string; language?: string }) {
		return this.http
			.post(environment.apiUrl + 'product/downloadPolicyDocument', body)
			.pipe(map((res: any) => res.result as { documentId: number | null; fileName: string; file: string }));
	}

	getFilesContent(body: Cliente) {
		return this.http
			.post(environment.apiUrl + 'quote/showFilesContent', body)
			.pipe(map((res: any) => res.result as { documentId: number; documentTypeId: number; file: string; filename?: string }[]));
	}

	getQuoteFlag(token: string) {
		return this.http
			.post(environment.apiUrl + 'quote/getQuoteFlagsByToken', {token: token})
			.pipe(map((res: any) => res.result as { hasAcceptedPrivacy: boolean; hasAcceptedMarketing: boolean; unsubscribed: boolean }));
	}

	getWithdrawalInfo(token: string, language: string) {
		return this.http
			.post(environment.apiUrl + 'quote/withdrawal-info', { token, language })
			.pipe(map((res: any) => res.result as { firstName?: string; lastName?: string; phone?: string; email?: string; policyNumber?: string; certificateNumber?: string }));
	}

	inviaRecesso(body: { token: string; tenantId: number; language: string; firstName: string; lastName: string; phone: string; email: string; policyNumber: string }) {
		return this.http.post(environment.apiUrl + 'quote/withdrawal', body).pipe(map((res: any) => res.result));
	}
}